import type { BulkUploadRepository } from "../repositories/BulkUploadRepository";

export class DownloadCustomerTemplateUseCase {
  constructor(private readonly repository: BulkUploadRepository) {}

  async execute(): Promise<void> {
    await this.repository.downloadCustomerTemplate();
  }
}
